import { getChecksumAddress } from "starknet";

export const isValidStarknetAddress = (address: string): boolean =>{
  const checksum = getChecksumAddress(address);
  const isValidChecksum = checksum.toLowerCase() === address.toLowerCase();

  return isValidChecksum;
}